import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './Login.css'

export default function Login() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [mfaRequired, setMfaRequired] = useState(false)
  const [mfaCode, setMfaCode] = useState('')
  const [setupUrl, setSetupUrl] = useState(null)

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!email || !password) {
      setError(t('login.errors.emptyFields'))
      return
    }
    if (mfaRequired && !mfaCode.trim()) {
      setError(t('login.mfaPrompt'))
      return
    }

    setLoading(true)
    setError('')

    try {
      const code = mfaCode.trim()
      const response = await fetch('/api/auth/login?training=true', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', 'x-training-login': 'true' },
        body: JSON.stringify({
          email,
          password,
          ...(mfaRequired && code ? (/^\d{6}$/.test(code) ? { mfaCode: code } : { backupCode: code }) : {})
        }),
      })
      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        if (data.setupRequired) {
          setSetupUrl(data.setupUrl || '/mfa-setup?next=/training/login')
          setError(data.message || data.error)
        } else if (data.requiresMFA) {
          setMfaRequired(true)
          setError(mfaRequired ? (data.error || t('login.errors.failed')) : '')
        } else {
          setError(data.message || data.error || t('login.errors.failed'))
        }
        setLoading(false)
        return
      }

      // The session cookie (HttpOnly) was set by the login response.
      window.location.href = '/training/'
    } catch (err) {
      setError(t('login.errors.failedRetry'))
      setLoading(false)
    }
  }

  return (
    <div className="training-login-container">
      <button
        onClick={() => (window.location.href = "/")}
        className="home-button"
      >
        {t('login.backHome')}
      </button>
      <div className="login-box">
        <h1>{t('login.title')}</h1>
        <p className="tagline">{t('login.subtitle')}</p>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">{t('login.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('login.emailPlaceholder')}
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('login.password')}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('login.passwordPlaceholder')}
              disabled={loading}
              required
            />
          </div>

          {mfaRequired && (
            <div className="form-group">
              <label htmlFor="mfa">{t('login.mfaLabel')}</label>
              <input
                id="mfa"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value)}
                placeholder={t('login.mfaPlaceholder')}
                disabled={loading}
                autoFocus
              />
              <small style={{ color: '#6b7280' }}>{t('login.mfaPrompt')}</small>
            </div>
          )}

          {error && <div className="error-message">{error}</div>}

          {setupUrl && (
            <button type="button" className="login-button" style={{ marginBottom: '0.75rem' }}
              onClick={() => { window.location.href = setupUrl }}>
              {t('login.setupMfa')}
            </button>
          )}

          <button type="submit" disabled={loading} className="login-button">
            {loading ? t('login.loadingButton') : t('login.submitButton')}
          </button>
        </form>
      </div>
    </div>
  )
}
